import _ from "lodash";
import * as types from "../types";
import { changeCaseOn, createFormData } from "../utils";

export const getEPosters = ({ tags, profileId, title, internalId, sort, page, perPage }) => {
  const request = {
    type: types.GET_EPOSTERS,
    request: {
      url: "/eposters",
      method: "GET",
      params: {
        "q[tagged_with_all]": JSON.stringify(tags),
        "q[accademics_id_eq]": profileId,
        "q[s]": sort,
        "q[title_i_cont]": title,
        "q[internal_id_eq]": internalId,
        page,
        per_page: perPage
      }
    }
  };
  if (page && parseInt(page, 10) !== 1) {
    request.meta = {
      mutations: {
        [types.GET_EPOSTERS]: (prevData, newData) => {
          if (newData.meta.current_page <= prevData.meta.current_page) return newData;
          return { ...newData, data: prevData.data.concat(newData.data) };
        }
      }
    };
  }
  return request;
};

export const getEPoster = ({ id }) => ({
  type: types.GET_EPOSTER,
  request: {
    url: `/eposters/${id}`,
    method: "GET"
  }
});

export const getEPosterQAs = ({ ePosterId }) => ({
  type: types.GET_EPOSTER_QAS,
  request: {
    url: `/eposters/${ePosterId}/question_answers`,
    method: "GET"
  }
});

export const createQuestionAnswer = ({ ePosterId, question }) => ({
  type: types.CREATE_EPOSTER_QA,
  request: {
    url: `/eposters/${ePosterId}/question_answers`,
    method: "POST",
    data: {
      questionAnswer: {
        question
      }
    }
  },
  meta: {
    mutations: {
      [types.GET_EPOSTER_QAS]: (prevData, newData) => {
        return { ...prevData, data: [...prevData.data, newData.data] };
      }
    }
  }
});

export const getRelatedEPosters = ({ id }) => ({
  type: types.GET_RELATED_EPOSTERS,
  request: {
    url: "/eposters",
    method: "GET",
    params: {
      "q[all_related_eposters]": id
    }
  }
});

export const createEposter = ({ eposter }) => {
  const formData = new FormData();
  const eposterData = changeCaseOn("snakeCase", eposter, ["document"]);
  createFormData(formData, "eposter", eposterData);

  formData.append(`eposter[document]`, eposter.document);
  formData.append(`eposter[tag_list]`, eposter.tag_list);

  if (eposter.videoUrl1) formData.append(`eposter[video_url_1]`, eposter.videoUrl1);
  if (eposter.videoUrl2) formData.append(`eposter[video_url_2]`, eposter.videoUrl2);
  if (eposter.videoUrl3) formData.append(`eposter[video_url_3]`, eposter.videoUrl3);

  return {
    type: types.CREATE_EPOSTER,
    request: {
      url: "/eposters",
      method: "POST",
      headers: {
        "Content-Type": "multipart/form-data"
      },
      data: formData
    },
    meta: {
      mutations: {
        [types.GET_EPOSTERS]: (prevData, newData) => {
          const data = _.sortBy([...prevData.data, newData.data], ["title"]);
          return { ...prevData, data };
        },
        [types.GET_MY_POSTERS]: (prevData, newData) => {
          const data = _.sortBy([...prevData.data, newData.data], ["title"]);
          return { ...prevData, data };
        }
      }
    }
  };
};

export const updateEposter = ({ id, eposter }) => {
  const formData = new FormData();
  const eposterData = changeCaseOn("snakeCase", eposter, ["document"]);
  createFormData(formData, "eposter", eposterData);

  formData.append(`eposter[tag_list]`, eposter.tag_list);
  if (eposter.document) formData.append(`eposter[document]`, eposter.document);

  if (eposter.videoUrl1) formData.append(`eposter[video_url_1]`, eposter.videoUrl1);
  if (eposter.videoUrl2) formData.append(`eposter[video_url_2]`, eposter.videoUrl2);
  if (eposter.videoUrl3) formData.append(`eposter[video_url_3]`, eposter.videoUrl3);
  return {
    type: types.UPDATE_EPOSTER,
    request: {
      url: `/eposters/${id}`,
      method: "PATCH",
      headers: {
        "Content-Type": "multipart/form-data"
      },
      data: formData
    },
    meta: {
      mutations: {
        [types.GET_EPOSTER]: (prevData, newData) => {
          return newData;
        },
        [types.GET_EPOSTERS]: (prevData, newData) => {
          const data = _.sortBy(
            [..._.filter(prevData.data, x => x.id !== newData.data.id), newData.data],
            ["title"]
          );
          return {
            ...prevData,
            data
          };
        },
        [types.GET_MY_POSTERS]: (prevData, newData) => {
          const data = _.sortBy(
            [..._.filter(prevData.data, x => x.id !== newData.data.id), newData.data],
            ["title"]
          );
          return {
            ...prevData,
            data
          };
        }
      }
    }
  };
};

export const deleteEposter = ({ id }) => ({
  type: types.DELETE_EPOSTER,
  request: {
    url: `/eposters/${id}`,
    method: "DELETE"
  },
  meta: {
    mutations: {
      [types.GET_EPOSTERS]: prevData => {
        return {
          ...prevData,
          data: [..._.filter(prevData.data, x => x.id !== id)]
        };
      },
      [types.GET_MY_POSTERS]: prevData => {
        return {
          ...prevData,
          data: [..._.filter(prevData.data, x => x.id !== id)]
        };
      }
    }
  }
});

export const getEPostersInternalIds = () => ({
  type: types.GET_EPOSTERS_INTERNAL_IDS,
  request: {
    url: "/eposters/internal_ids",
    method: "GET",
    params: {
      "q[s]": "internal_id asc"
    }
  }
});
